import { api } from 'src/api';
import {
// getParent,
types } from 'mobx-state-tree';
// import { toJS } from 'mobx';
// import { rootStore } from 'src/stores/configureStore/configureStore';
import { createAsync } from 'src/utils/asyncModel';
// import moment from 'moment/moment';

// NOTE: ======= API section start
// NOTE: Account
const setAccountPropertyUtilityAsync = createAsync(_ref => {
  let urjanetId = _ref.urjanetId,
    livablePropertyUtilityId = _ref.livablePropertyUtilityId;
  return async function setAccountPropertyUtility(data, options) {
    const resp = await api.Urjanet.patchAccount({
      urjanetId,
      livablePropertyUtilityId
    }, options);
    return resp;
  };
});

// NOTE: Credentials
const saveCredentialsAsync = createAsync(_ref2 => {
  let userName = _ref2.userName,
    password = _ref2.password,
    livableProviderId = _ref2.livableProviderId,
    propertyId = _ref2.propertyId;
  return async function saveCredentials(data, options) {
    const resp = await api.Urjanet.postCredentials({
      userName,
      password,
      livableProviderId,
      propertyId
    }, options);
    return resp;
  };
});
const updateCredentialsAsync = createAsync(_ref3 => {
  let userName = _ref3.userName,
    password = _ref3.password,
    urjanetCredentialId = _ref3.urjanetCredentialId;
  return async function updateCredentials(data, options) {
    const resp = await api.Urjanet.putCredentials({
      userName,
      password,
      urjanetCredentialId
    }, options);
    return resp;
  };
});
const deleteCredentialsAsync = createAsync(_ref4 => {
  let id = _ref4.id;
  return async function updateCredentials(data, options) {
    const resp = await api.Urjanet.deleteCredentials({
      id
    }, options);
    return resp;
  };
});
const getCompanyCredentialsAsync = createAsync(() => {
  return async function getCompanyCredentials(data, options) {
    const resp = await api.Urjanet.getCredentials(options);
    return resp;
  };
});
const getProviderIdsWithStoredCredentialsAsync = createAsync(() => {
  return async function getProviderIdsWithStoredCredentials(data, options) {
    const resp = await api.Urjanet.getCredentialProviders(options);
    return resp;
  };
});

// NOTE: Statement
// TODO:
const getProviderStatementsPreviewAsync = createAsync(_ref5 => {
  let livableProviderId = _ref5.livableProviderId;
  return async function getProviderStatementsPreview(data, options) {
    const resp = await api.Urjanet.getProviderStatements({
      livableProviderId
    }, options);
    return resp;
  };
});
// NOTE: Webhook
// TODO:

// NOTE: ======= API section end
// *********************************
// NOTE: ======= Store section start

const UrjanetStore = types.model('UrjanetStore', {
  setAccountPropertyUtilityAsync,
  saveCredentialsAsync,
  updateCredentialsAsync,
  deleteCredentialsAsync,
  getCompanyCredentialsAsync,
  getProviderIdsWithStoredCredentialsAsync,
  getProviderStatementsPreviewAsync
});
// .actions(self => ({
// setUtilityAfterLoad(data) {
//   try {
//     self.utilitiesValue = data.response.utilities.reduce(
//       (acc, item) => {
//         acc[item.utilityId] = {
//           cad: item.cad,
//           defaultAllocationMethod: item.defaultAllocationMethod,
//           defaultVacantUnitUsage: item.defaultVacantUnitUsage,
//           paidBy: item.paidBy,
//           providerName: item.providerName,
//           utilityTypeId: item.utilityTypeId,
//           utilityTypeName: item.utilityTypeName,
//         };
//         return acc;
//         // }, {});
//       },
//       Object.fromEntries(toJS(self.utilitiesValue))
//     );
//   } catch (error) {
//     console.log('STORE ERROR > setUtilityAfterLoad', error);
//   }
// },
// }))
// .views(self => ({
//   // get utilities() {
//   //   return self.utilitiesValue;
//   // },
// }));
// NOTE: ======= Store section end

export const urjanet = types.optional(UrjanetStore, {});